// Scale bridge dashboard - who is connected, and to which receiver.
//
// Holds an operator JWT and which receiver it belongs to.
//
// It did once hold only a view key - a receiver with no accounts still works that
// way, and Session carries both. Phases 2-4 added real identity, so this is now the
// thing that decides whether the app shows a dashboard or a sign-in screen, and
// whether the live feed may open a socket at all.

import { create } from 'zustand';
import { clearSession, loadSession, saveSession, type Session } from '../api/client';

interface AuthState {
    session: Session | null;
    signIn: (session: Session) => void;
    signOut: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
    // Read once at module load so a refresh does not bounce the operator back to
    // the key prompt.
    session: loadSession(),

    signIn: (session) => {
        saveSession(session);
        set({ session });
    },

    signOut: () => {
        clearSession();
        set({ session: null });
    },
}));
